import {
  IResourceDetailList,
  IResourceList,
} from 'src/components/challenge/ChallengeInterfaces';
import {
  ResourceTypeDetailEnum,
  ResourceTypeEnum,
  UserResourceEnum,
} from 'src/shared/enums';
import {
  IChallengeQuizDermo,
  IQuizDermoQuestion,
  IQuizDermoAnswer,
} from 'src/shared/models';
import moment from 'moment';

const { QUIZ_DERMO_PARTICIPATION, QUESTION, ANSWER } = ResourceTypeEnum;

const { CORRECT } = ResourceTypeDetailEnum;

export const buildChallengeQuizDermo = (
  resource: IResourceList,
): Partial<IChallengeQuizDermo> => {
  const {
    resourceList,
    resourceDetailList,
    name: title,
    idResource,
  } = resource;
  let challengeQuizDermo: Partial<IChallengeQuizDermo>;
  const questions: IQuizDermoQuestion[] = [];
  // ? Number of questions in the Quiz. Used to know which is the last
  let totalQuestions = 0;
  let totalPoints = 0;
  let isLastQuestion = false;
  let isQuizDone = false;
  // TODO: este userStatus en realidad no lo estamos usando para nada en Dermo
  let userStatus = UserResourceEnum.INACTIVE;

  // ? Get the sum of the points from the answers
  resourceList
    .filter(({ status }) => status)
    .forEach((resource: IResourceList, index: number, elements) => {
      switch (resource.idResourceType.idResourceType) {
        case QUIZ_DERMO_PARTICIPATION:
          const usersM2MList = resource.usersM2MList
            .filter((item) => item.status)
            .pop();

          if (Boolean(usersM2MList)) {
            userStatus = usersM2MList.statusResource as UserResourceEnum;

            if (userStatus === UserResourceEnum.DONE) isQuizDone = true;
          }

          break;
        case QUESTION:
          resource.resourceList
            .filter((resource: IResourceList) => {
              return (
                resource.idResourceType.idResourceType === ANSWER &&
                resource.status
              );
            })
            .forEach((resource: IResourceList) => {
              totalPoints += resource.score?.points;
            });

          totalQuestions++;
          isLastQuestion = totalQuestions === elements.length - 1;

          const { points, question } = buildQuizQuestion(
            resource,
            isLastQuestion,
          );

          questions.push(question);

          break;
        default:
          break;
      }
    });

  return {
    title,
    idResource,
    points: totalPoints || 0,
    isQuizDone,
    isCompleted: isQuizDone,
    isLastQuiz: false,
    questions,
    totalResponses: 0,
    userStatus,
  };
};

// * --------------------------------------------------------------------  questions
const buildQuizQuestion = (
  questionData: IResourceList,
  isLastQuestion: boolean,
): { points: number; question: IQuizDermoQuestion } => {
  const { name, idResource, indResource, i18nList } = questionData;
  const answers: IQuizDermoAnswer[] = [];
  //let urlVideo: string;
  //let urlImage: string;
  let score = 0;
  //let textJustification: string;
  let hasCorrectAnswer = false;

  /*
  questionData.resourceDetailList
    .filter(_detail => _detail.status)
    .forEach((resource: IResourceDetailList) => {
      switch (resource.idResourceTypeD.idResourceTypeD) {
        case QUIZ_VIDEO_URL:
          urlVideo = resource.value;
          break;
        case QUESTION_IMAGE_URL:
          urlImage = resource.value;
          break;
        case QUESTION_JUSTIFICATION:
          textJustification = resource.value;
          break;
      }
    });
  */

  questionData.resourceList
    .filter((resource) => resource.status)
    .forEach((answerData: IResourceList) => {
      if (answerData.idResourceType.idResourceType === ANSWER) {
        const { points, answer } = buildQuizAnswer(answerData);

        hasCorrectAnswer = hasCorrectAnswer || answer.isCorrect;

        answers.push(answer);

        score = Math.max(score, points);
      }
    });

  //const format = Boolean(urlVideo) ? urlVideo.split('.') : '';
  //const isFromFile = isVideoValidFormat(format[format?.length - 1]);

  // TODO: este objeto está usando los mismos campos que el de PIN..
  // TODO: quitar los que no se usen para Dermo (y tb en 'IQuizDermoQuestion')
  return {
    points: score,
    question: {
      idResource,
      indResource,

      answers,
      i18nList,
      score,
      title: name,

      hasAnswers: answers.length > 0,
      hasCorrectAnswer,
      hasImage: false,
      hasJustification: false,
      hasVideo: false,
      isLastQuestion,
      isVideoFromFile: false,

      textJustification: '',
      urlImage: '',
      urlVideo: '',
    },
  };
};

// * --------------------------------------------------------------------  answers
const buildQuizAnswer = (
  answerData: IResourceList,
): { points: number; answer: IQuizDermoAnswer } => {
  let isCorrect = false;
  let alreadyAnswered = false;

  const {
    indResource,
    idResource,
    name,
    i18nList,
    resourceDetailList,
    score,
    usersM2MList,
  } = answerData;

  resourceDetailList
    .filter((resourceDetail) => resourceDetail.status)
    .forEach((detail: IResourceDetailList) => {
      if (detail.idResourceTypeD.idResourceTypeD === CORRECT) {
        isCorrect = detail.value === 'true';
      }
    });
  if (usersM2MList?.length) alreadyAnswered = true;

  const points = !score ? 0 : score.points;

  return {
    points,
    answer: {
      indResource,
      idResource,
      name,
      i18nList,
      isCorrect,
      userResponses: 0,
      score: points,
      alreadyAnswered,
    },
  };
};
